import { LadzoConsole as Lc } from "../global/ladzo-console.js";
import { createApp } from "vue";
import App from "../../vue/mapaApp.vue";
export function zobrazMapu() {
  Lc.f("zobrazMapu pres mapaApp");
  createApp(App).mount("#dvApp");
}
